import React from 'react';
import styled from 'styled-components';
import { IToastAction, ToastProps } from './HBToast.types';
import HBButton from '../HBButton/HBButton';

interface Props {
    actions: ToastProps['actions'];
    onActionClick: (action: IToastAction) => void;
}

const ToastActions = ({ actions, onActionClick }: Props) => {
    return (
        <ActionsContainer>
            {actions.map(action => (
                <HBButton
                    buttonTheme={action.theme}
                    customTheme={action.customTheme}
                    key={action.text}
                    onClick={() => onActionClick(action)}
                    size={action.size}
                    testId={
                        action.testIdName
                            ? `hb-toast-${action.testIdName}-action--button`
                            : undefined
                    }
                    testIdType="hb-toast-action--button"
                >
                    {action.text}
                </HBButton>
            ))}
        </ActionsContainer>
    );
};

export default ToastActions;

// -------------------------------- Styles -------------------------------- //
const ActionsContainer = styled.div`
    display: flex;
    gap: 12px;
`;
